import LTVbeDictSection from "./components/LTVbeDictSection";

const LTVbePage: React.FC = () => {
  return (
    <div>
      <LTVbeDictSection />
    </div>
  );
};

export default LTVbePage;
